var map = {
	"./pt/1/image4.png": [
		18899,
		8899
	],
	"./pt/10/image4.png": [
		40649,
		649
	],
	"./pt/2/image4.png": [
		89137,
		9137
	],
	"./pt/3/image4.png": [
		11248,
		1248
	],
	"./pt/4/image4.png": [
		94103,
		4103
	],
	"./pt/5/image4.png": [
		80725,
		725
	],
	"./pt/6/image4.png": [
		51705,
		1705
	],
	"./pt/7/image4.png": [
		30877,
		877
	],
	"./pt/8/image4.png": [
		51791,
		1791
	],
	"./pt/9/image4.png": [
		12648,
		2648
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 75278;
module.exports = webpackAsyncContext;